import {UmpirePublicationCategory} from '../umpire-publication-category';
import {UmpireImage} from '../umpire-image';
import {UmpireVisibilityOption} from '../umpire-visibility-options';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export interface UmpirePageType {
  type: string;

  id: string;

  client_id: string;

  name: string;

  kind: string;

  slug: string | null;

  allowed_component_kinds: UmpireComponentTypeEnum[];

  visibility: UmpireVisibilityOption[];

  image: UmpireImage;

  publication_categories: UmpirePublicationCategory[];
}
